import { useState, useRef } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Image as ImageIcon, UploadCloud, Loader2 } from "lucide-react";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, label, wide = false, testId }) {
  const [uploading, setUploading] = useState(false);
  const inputRef = useRef(null);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("الرجاء اختيار ملف صورة");
      return;
    }
    if (file.size > 8 * 1024 * 1024) {
      toast.error("الصورة كبيرة جداً (الحد الأقصى 8 ميجابايت)");
      return;
    }
    setUploading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/admin/upload-image", form, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onChange(data.url);
      toast.success("تم رفع الصورة ✓");
    } catch (err) {
      toast.error(err.response?.data?.detail || "فشل رفع الصورة، حاول مرة أخرى");
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = "";
    }
  };

  return (
    <div>
      {label && <Label>{label}</Label>}
      <div className="mt-1.5 flex items-start gap-3">
        <div className={`${wide ? "w-32 h-20" : "w-20 h-20"} rounded-lg border border-[#EAEAEA] bg-[#F7F7F7] overflow-hidden flex items-center justify-center flex-shrink-0`}>
          {value ? (
            <img src={value} alt="" className="w-full h-full object-cover" />
          ) : (
            <ImageIcon className="w-6 h-6 text-[#BDBDBD]" />
          )}
        </div>
        <div className="flex flex-col gap-2 pt-1">
          <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid={testId} />
          <Button
            type="button"
            size="sm"
            variant="outline"
            disabled={uploading}
            onClick={() => inputRef.current?.click()}
            className="rounded-full"
            data-testid={testId ? `${testId}-btn` : undefined}
          >
            {uploading ? (
              <><Loader2 className="w-3.5 h-3.5 me-1.5 animate-spin" /> جاري الرفع...</>
            ) : (
              <><UploadCloud className="w-3.5 h-3.5 me-1.5" /> {value ? "تغيير الصورة" : "رفع من الجهاز"}</>
            )}
          </Button>
          {value && (
            <button type="button" onClick={() => onChange("")} className="text-xs text-red-600 hover:underline text-start">
              إزالة الصورة
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
